<!--
    描述：租户列表
    日期：2021/04/06
    作者：zwh
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="tableContent">
				<el-table :data="tenantTreeData.tableData"
						  row-key="id"
						  v-loading="tenantTreeData.loading"
						  ref="tenantTree"
						  :expand-row-keys="tenantTreeData.expandKeys"
						  :height="tenantTreeData.tableH"
						  border
						  highlight-current-row
						  default-expand-all
						  @row-click="rowClick"
						  :tree-props="{children: 'children'}">
					<el-table-column prop="sname"
									 label="名称"
									 align="center"
									 header-align="center"
									 show-overflow-tooltip
									 min-width="120">
						<template v-slot="{ row }">
							<div slot="reference"
								 class="detail-name"
								 @click="doClick('view', row)">
								{{row.sname}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="limitName"
									 label="单位主体"
									 align="center"
									 header-align="center"
									 show-overflow-tooltip
									 min-width="80"></el-table-column>
					<el-table-column label="操作"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="50">
						<template slot-scope="scope">
							<!-- <el-button size="mini"
									   icon="el-icon-circle-plus-outline"
									   title="新增"
									   type="text"
									   v-if="roleBtns.includes('tenant_add')"
									   @click="doClick('add', scope.row)"></el-button> -->
							<el-button size="mini"
									   icon="el-icon-edit"
									   title="编辑"
									   type="text"
									   v-if="roleBtns.includes('tenant_edit')"
									   @click="doClick('edit', scope.row)"></el-button>
							<el-button size="mini"
									   icon="el-icon-delete"
									   title="删除"
									   type="text"
									   v-if="roleBtns.includes('tenant_delete')"
									   @click="doClick('delete', scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   top="4vh"
				   :close-on-click-modal="false"
				   @closed="handleClose"
				   class="dialog-style-save-edit">
			<!-- 弹窗组件 -->
			<div v-if="dialogObj.visible"
				 class="min-height600"
				 v-loading="contentLoading">
				<el-collapse v-model="activeName">
					<el-collapse-item title="#1 企业基本信息"
									  name="1">
						<el-form :model="objectForm"
								 :rules="formRules"
								 ref="objectForm"
								 size="small"
								 label-width="150px">
							<el-row>
								<el-col :span="12">
									<el-form-item v-if="objectForm.parentId != 0"
												  label="父级"
												  prop="parentName"
												  :show-message="false">
										<el-input v-model="objectForm.parentName"
												  autocomplete="off"
												  disabled
												  :show-message="false"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="企业/组织名称"
												  prop="sname">
										<el-input v-model="objectForm.sname"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="企业/组织简称"
												  prop="shortName">
										<el-input v-model="objectForm.shortName"
												  :disabled="isDisabled"
												  placeholder="请输入"
												  :maxlength="8"
												  show-word-limit></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<span class="red">*企业/组织可以是一个企业或者是一个组织部门</span>
								</el-col>
								<el-col :span="12">
									<el-form-item label="主体类型"
												  prop="limitId">
										<el-select v-model="objectForm.limitId"
												   :disabled="limitDisabled"
												   placeholder="请选择">
											<el-option v-for="item in limits"
													   :key="item.id"
													   :label="item.sname"
													   :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12"
										v-if="objectForm.limitId == '1382233551767498754' || objectForm.limitId == '1382233569480044546'">
									<el-form-item label="项目归属区域"
												  prop="area">
										<el-select v-model="objectForm.area"
												   :disabled="isDisabled"
												   placeholder="请选择">
											<el-option v-for="item in projectDict.xmgsqy"
													   :key="item.value"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="社会统一信用代码"
												  prop="creditCode">
										<el-input v-model="objectForm.creditCode"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="单位性质"
												  prop="companyType">
										<el-select v-model="objectForm.companyType"
												   :disabled="isDisabled"
												   placeholder="请选择">
											<el-option v-for="item in dwlx"
													   :key="item.id"
													   :label="item.sname"
													   :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="法人代表"
												  prop="legal">
										<el-input v-model="objectForm.legal"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="法人代表手机号"
												  prop="legalPhone">
										<el-input v-model="objectForm.legalPhone"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="法人代表身份证号"
												  prop="legalIdCard">
										<el-input v-model="objectForm.legalIdCard"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="办公地址"
												  prop="address">
										<el-input v-model="objectForm.address"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="企业联系人"
												  prop="linkman">
										<el-input v-model="objectForm.linkman"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="联系人手机号"
												  prop="linkPhone">
										<el-input v-model="objectForm.linkPhone"
												  :disabled="isDisabled"
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									{{objectForm.industryArray}}
									<el-form-item label="所属行业"
												  prop="industryArray">
										<el-cascader :options="tradeList"
													 :props="props"
													 :disabled="isDisabled"
													 size="small"
													 placeholder="请选择"
													 v-model="objectForm.industry"></el-cascader>
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="备注"
												  prop="remark">
										<el-input v-model="objectForm.remark"
												  type="textarea"
												  :disabled="isDisabled"
												  :autosize="{ minRows: 3 }"
												  maxlength="200"
												  show-word-limit
												  placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</el-collapse-item>
					<el-collapse-item title="#2 企业账户信息"
									  name="2">
						<el-row>
							<el-col :span="4"
									:offset="20"
									class="text-right">
								<el-button type="primary"
										   size="small"
										   icon="el-icon-plus"
										   :disabled="isDisabled"
										   @click="addAccount">新增企业账户</el-button>
							</el-col>
							<el-col :span="24"
									class="mt10">
								<vxe-table align="center"
										   resizable
										   border
										   :data="accountObj.table"
										   highlight-current-row
										   :loading="accountObj.loading"
										   show-overflow="tooltip"
										   show-header-overflow="tooltip">
									<vxe-table-column title="序号"
													  type="seq"
													  width="70"></vxe-table-column>
									<vxe-table-column title="收款户名"
													  field="sname"></vxe-table-column>
									<vxe-table-column title="收款账号"
													  field="account"></vxe-table-column>
									<vxe-table-column title="开户银行"
													  field="openBankName"></vxe-table-column>
									<vxe-table-column title="支行"
													  field="subBank"></vxe-table-column>
									<vxe-table-column title="设置默认收款账户"
													  field="isDefault">
										<template #default="{ row }">
											<vxe-switch v-model="row.isDefault"
														open-label="是"
														:open-value="1"
														close-label="否"
														:close-value="0"
														disabled
														:class="{ hideStyle: isDisabled }"
														@click.native.prevent="handleSwitch(row)"></vxe-switch>
										</template>
									</vxe-table-column>
									<vxe-table-column title="操作">
										<template #default="{ row }">
											<el-button size="mini"
													   icon="el-icon-edit"
													   title="编辑"
													   type="text"
													   :disabled="isDisabled"
													   @click="accountClick('edit', row)"></el-button>
											<el-button size="mini"
													   icon="el-icon-delete"
													   title="删除"
													   type="text"
													   :disabled="isDisabled"
													   @click="accountClick('delete', row)"></el-button>
										</template>
									</vxe-table-column>
								</vxe-table>
							</el-col>
						</el-row>
					</el-collapse-item>
				</el-collapse>

			</div>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消
				</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定
				</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="accountObj.title"
				   :visible.sync="accountObj.show"
				   width="1000px"
				   :close-on-click-modal="false"
				   center
				   @close="doCloseAccount">
			<el-row :gutter="10"
					v-if="accountObj.show">
				<el-form ref="accountForm"
						 :model="accountForm"
						 :rules="accountRule"
						 label-width="140px"
						 size="small"
						 class="account-item">
					<el-col :span="12">
						<el-form-item label="收款户名"
									  prop="sname">
							<el-input v-model="accountForm.sname"
									  placeholder="默认企业/组织名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="收款账号"
									  prop="account">
							<el-input v-model="accountForm.account"
									  maxlength="24"
									  placeholder="请输入企业/组织收款账号"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开户银行"
									  prop="openBank">
							<el-select v-model="accountForm.openBank"
									   placeholder="请选择开户银行">
								<el-option v-for="item in projectDict.khh"
										   :key="item.value"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="支行"
									  prop="subBank">
							<el-input v-model="accountForm.subBank"
									  placeholder="请输入支行"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="设为默认收款账户">
							<vxe-switch v-model="accountForm.isDefault"
										open-label="是"
										:open-value="1"
										close-label="否"
										:close-value="0"></vxe-switch>
						</el-form-item>
					</el-col>
				</el-form>
			</el-row>
			<div slot="footer">
				<el-button @click="doCloseAccount('no')">取 消</el-button>
				<el-button type="primary"
						   :loading="accountBtnLoading"
						   @click="doSubmitAccount">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import {
	saveOrUpdate,
	getTreeTableList,
	deleteById,
	getObjectById,
	getDictsByKey,
	getIndustryCodeTree,
	saveTenantAccount,
	getTenantAcounts,
	deleteTenantAcount,
	changeDefaultAcount,
} from 'api/system/sysTenant'
import { getLimits } from 'api/unitMaintain/unit'
import { getUserList } from 'api/system/user'

export default {
	components: {},
	data() {
		return {
			props: {
				checkStrictly: true,
				emitPath: false,
				expandTrigger: 'hover',
			},
			limitDisabled: false,
			isDisabled: false,
			tradeList: [],
			dwlx: [],
			limits: [],
			btnLoading: false,
			selectUserList: [],
			tenantTreeData: {
				loading: false,
				tableH: 200,
				tableData: [],
				defaultData: [],
				expandKeys: [],
			},
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: '',
			},
			dialogObj: {
				title: '',
				visible: false,
				width: '1200px',
				mode: 'add',
			},
			objectForm: {
				id: '',
				parentId: '',
				parentName: '',
				limitId: '',
				sname: '',
			},
			formRules: {
				sname: [
					{ required: true, message: '请输入...', trigger: 'blur' },
				],
				shortName: [
					{ required: true, message: '请选择...', trigger: 'blur' },
				],
				limitId: [
					{ required: true, message: '请选择...', trigger: 'change' },
				],
				area: [
					{ required: true, message: '请选择...', trigger: 'change' },
				],
				legal: [
					{ required: true, message: '请选择...', trigger: 'blur' },
				],
				legalPhone: [
					{
						required: true,
						message: '请输入手机号',
						trigger: 'blur',
					},
					{
						pattern: /^1[3-9][0-9]{9}$/,
						message: '手机号码格式不正确，请重新输入',
					},
				],
				legalIdCard: [
					{
						pattern:
							/^[1-9][0-9]{5}(18|19|(2[0-9]))[0-9]{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)[0-9]{3}[0-9Xx]$/,
						message: '身份证输入有误',
					},
				],
				linkPhone: [
					{
						pattern: /^1[3-9][0-9]{9}$/,
						message: '手机号码格式不正确，请重新输入',
					},
				],
			},

			clickRowObj: '',
			activeName: ['1', '2'],
			accountObj: {
				table: [],
				loading: false,
				title: '',
				show: false,
			},
			selectCompany: {}, //当前操作的公司
			accountForm: {
				tenantId: '', //企业id
				sname: '', //账户名
				account: '', //账户
				openBank: '', //开户行
				subBank: '', //支行
				isDefault: 0, //支行
			},
			accountBtnLoading: false,
			accountRule: {
				sname: [{ required: true, message: '不能为空...' }],
				account: [
					{ required: true, message: '不能为空...' },
					{
						pattern: /^\d{9,24}$/,
						message: '由数字组成，长度为9~24位',
					},
				],
				openBank: [{ required: true, message: '不能为空...' }],
				subBank: [{ required: true, message: '不能为空...' }],
			},
			contentLoading: false,
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tenantTreeData.tableH =
					this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
	},
	watch: {
		clientSize(val) {
			this.tenantTreeData.tableH = this.$refs.tableContent.offsetHeight
		},
	},
	created() {
		getDictsByKey().then((res) => {
			this.dwlx = res.data.dwxz
		})
		getIndustryCodeTree().then((res) => {
			this.tradeList = res.data
		})
		this.getUserList()
		this.getTreeTableList()
		this.getLimits()
	},
	methods: {
		// 获取企业账户列表
		getTenantAcounts() {
			this.accountObj.loading = true
			getTenantAcounts({
				tenantId: this.selectCompany.id,
			})
				.then((res) => {
					this.accountObj.table = res.data
					this.accountObj.loading = false
				})
				.catch(() => {
					this.accountObj.loading = false
				})
		},

		// 新增账户
		async addAccount() {
			let status = await this.$deleteConfirm(
				'此操作需先保存企业基本信息, 是否继续?',
				true
			)
			if (status) {
				this.doSave('no')
			} else {
				this.$message.info('已取消操作！')
			}
		},

		// 添加账户弹窗关闭
		doCloseAccount() {
			this.accountForm.id = ''
			this.accountForm.sname = ''
			this.accountForm.account = ''
			this.accountForm.openBank = ''
			this.accountForm.subBank = ''
			this.accountForm.isDefault = 0
			this.accountObj.show = false
			this.accountObj.title = ''
		},

		// 添加账户弹窗确认
		doSubmitAccount() {
			this.$refs.accountForm.validate((valid) => {
				if (valid) {
					this.accountBtnLoading = true
					let params = this.$utils.clone(this.accountForm, true)
					params.tenantId = this.selectCompany.id
					saveTenantAccount(params)
						.then((res) => {
							this.accountBtnLoading = false
							this.$refs.accountForm.resetFields()
							this.accountObj.show = false
							this.getTenantAcounts()
						})
						.catch(() => {
							this.accountBtnLoading = false
						})
				} else {
					this.$message.error('请完善表单')
				}
			})
		},

		// 账户行点击
		async accountClick(type, row) {
			switch (type) {
				case 'edit':
					this.accountForm = this.$utils.clone(row, true)
					this.accountObj.show = true
					this.accountObj.title = '编辑企业账户'
					break
				case 'delete':
					let status = await this.$deleteConfirm('该账户')
					if (status) {
						deleteTenantAcount({
							id: row.id,
						}).then((res) => {
							this.getTenantAcounts()
						})
					} else {
						this.$message.info('已取消操作！')
					}
					break
			}
		},

		// 是否必传change事件
		async handleSwitch(data) {
			if (this.isDisabled) {
				return
			}
			let status = await this.$deleteConfirm(
				'此操作将改变开关状态，是否确认',
				true
			)
			if (status) {
				changeDefaultAcount({
					id: data.id,
					tenantId: data.tenantId,
					isDefault: data.isDefault ? 0 : 1,
				}).then((res) => {
					this.$message.success('切换完成！')
					this.getTenantAcounts()
				})
			} else {
				this.$message.info('操作取消！')
			}
		},

		getUserList() {
			getUserList({}).then((res) => {
				if (res.operationCode == 1) {
					this.selectUserList = res.data
				}
			})
		},

		getTreeTableList() {
			let that = this
			let param = {}
			getTreeTableList(param).then((res) => {
				if (res.operationCode == 1) {
					this.tenantTreeData.tableData = that.$utils.toArrayTree(
						res.data
					)
					this.tenantTreeData.defaultData = JSON.parse(
						JSON.stringify(this.tenantTreeData.tableData)
					)

					if (this.tenantTreeData.tableData.length > 0) {
						this.rowClick(this.tenantTreeData.tableData[0])
						this.$refs.tenantTree.setCurrentRow(
							this.tenantTreeData.tableData[0]
						)
					}

					//重置选择租户获取主体信息
					that.$emit('reset-select-tenant')
				}
			})
		},

		// 筛选查询
		filterUnit(name) {
			let arr = this.$utils.filterTree(
				this.tenantTreeData.defaultData,
				(x) => x.sname.indexOf(name) >= 0
			)
			this.tenantTreeData.tableData = arr
		},

		// 确定按钮事件
		doSave(data) {
			let that = this
			if (data != 'no') {
				this.btnLoading = true
			}
			this.$refs['objectForm'].validate((valid) => {
				if (valid) {
					if (data == 'no') {
						this.contentLoading = true
					}
					// this.objectForm.industry = this.objectForm.industryArray.join(
					// 	','
					// )
					let param = this.objectForm
					saveOrUpdate(param)
						.then((res) => {
							this.btnLoading = false
							if (res.code == 0) {
								if (data == 'no') {
									that.selectCompany.id = res.data.id
									that.contentLoading = false
									that.accountObj.show = true
									that.accountObj.title = '新增企业账户'
									that.accountForm.sname =
										this.objectForm.sname
									if (!this.objectForm.id) {
										this.getObjectById(res.data)
									}
									return
								}
								that.$message({
									message: '保存成功',
									type: 'success',
								})

								that.dialogObj.visible = false
								that.getTreeTableList()
								//刷新菜单信息
								//that.$emit('handle-success')
								if (this.dialogObj.title == '编辑租户')
									this.$emit('row-click', this.clickRowObj)
							} else if (res.code == 1) {
								this.$message.error(res.msg)
							} else {
								this.$message.error('保存失败')
							}
						})
						.catch((err) => {
							this.contentLoading = false
							this.btnLoading = false
						})
				} else {
					this.btnLoading = false
				}
			})
		},

		doClick(type, obj) {
			let that = this
			that.selectCompany = obj
			that.dialogObj.mode = type
			this.isDisabled = false
			if (type === 'add') {
				this.resetForm()
				this.transObj.id = ''
				this.selectCompany = {}
				if (obj != '') {
					this.objectForm.parentId = obj.id
					this.objectForm.parentName = obj.sname
				} else {
					this.objectForm.parentId = '0'
					this.objectForm.parentName = ''
				}
				this.dialogObj.title = '新增单位'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				this.getTenantAcounts()
				this.resetForm()
				this.limitDisabled = true
				this.objectForm.id = obj.id
				this.objectForm.parentId = ''
				this.objectForm.parentName = ''
				this.dialogObj.title = '编辑单位'
				this.dialogObj.visible = true
				//根据id获取详细信息
				this.getObjectById(obj)
			} else if (type === 'view') {
				this.getTenantAcounts()
				this.resetForm()
				this.isDisabled = true
				this.limitDisabled = true
				this.objectForm.id = obj.id
				this.objectForm.parentId = ''
				this.objectForm.parentName = ''
				this.dialogObj.title = '查看单位'
				this.dialogObj.visible = true
				//根据id获取详细信息
				this.getObjectById(obj)
			} else if (type === 'delete') {
				this.delete(obj)
			}
		},

		getObjectById(obj) {
			let that = this
			let param = {
				id: obj.id,
			}
			getObjectById(param).then((res) => {
				if (res.operationCode == 1) {
					that.objectForm = res.data
					// that.objectForm.industryArray = res.data.industry.split(',')
				}
			})
		},

		delete(obj) {
			let that = this
			this.$confirm('删除租户、租户主体信息，确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				let param = {
					id: obj.id,
				}
				deleteById(param).then((res) => {
					if (res.operationCode == 1) {
						if (res.msg == 'faild') {
							that.$message({ message: res.data, type: 'error' })
							return
						}
						that.$message({ message: '删除成功', type: 'success' })
						that.getTreeTableList()

						this.clickRowObj = ''
						this.$emit('row-click', '')
					}
				})
			})
		},

		handleTools() {},

		//行点击事件
		rowClick(row) {
			this.clickRowObj = row
			this.$emit('row-click', row)
		},

		// 清除选中
		clearSelected() {
			this.$refs.tenantTree.setCurrentRow()
		},

		// 关闭弹窗事件
		handleClose() {
			this.accountObj.table = []
			this.getTreeTableList()
		},

		resetForm() {
			this.objectForm = {}
			this.limitDisabled = false
		},

		getLimits() {
			getLimits().then((res) => {
				this.limits = res.data
			})
		},
	},
}
</script>
<style lang="less" scoped>
.dialog-style-save-edit {
	.el-form-item {
		margin-bottom: 15px !important;
	}
}

.detail-name {
	color: #2671cc;
	cursor: pointer;
}
.min-height600 {
	min-height: 600px !important;
}
.account-item {
	/deep/ .el-form-item {
		margin-bottom: 15px !important;
	}
}
.el-collapse {
	border-bottom: none;
	.el-collapse-item {
		margin-bottom: 15px;
	}
	/deep/ .el-collapse-item__header {
		padding-left: 15px;
		font-size: 16px;
		background-color: #eff6fe;
	}
	/deep/ .el-collapse-item__wrap {
		border-bottom: none;
	}
	/deep/ .el-collapse-item__content {
		padding: 15px;
	}
}
.red {
	color: red;
	padding-left: 150px;
}
/deep/ .vxe-switch.is--disabled.is--off {
	opacity: 1;
}
/deep/ .vxe-switch.is--disabled .vxe-switch--button {
	cursor: pointer;
}
/deep/ .is--on {
	.vxe-switch--button {
		background-color: #409eff !important;
	}
}
.hideStyle {
	opacity: 0.5 !important;
	/deep/ .vxe-switch--button {
		cursor: not-allowed !important;
	}
}
</style>